import React, { type ComponentPropsWithoutRef } from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledBox = styled.div<{ height?: number; iconSize?: number }>(
	{
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		height: (props) => `${props.height ? props.height : 128}px`,
		justifyContent: 'center',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ iconSize }) =>
		iconSize
			? `svg {
                   width: ${iconSize}px;
                   height: ${iconSize}px;
               }`
			: '',
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledTextComponent = styled.div({
	marginTop: token('space.100'),
});

export const StyledText = (props: ComponentPropsWithoutRef<typeof StyledTextComponent>) => (
	<Heading size="xsmall">
		<StyledTextComponent {...props} />
	</Heading>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledControl = styled.div({
	display: 'flex',
	paddingTop: token('space.050'),
	paddingRight: token('space.050'),
	paddingBottom: token('space.050'),
	paddingLeft: token('space.050'),

	borderBottom: `solid 1px ${token('color.border')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CloseIconWrapper = styled.span({
	cursor: 'pointer',
	'&:hover': {
		color: token('color.background.neutral.bold.hovered'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DisplayWrapper = styled.div<{ displayFlag?: boolean | string }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	display: (props) => (props.displayFlag ? 'block' : 'none'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard,  Ignored via go/DSP-18766
export const CustomOptionStyles = styled.div<{
	hasIconAfter?: boolean;
	isFocused?: boolean;
	isSingleSelect?: boolean;
	isDisabled?: boolean;
}>(
	{
		/* @atlaskit/select is preventing us from overriding certain CSS properties using the styles API due to a bug. This
    is a temporary workaround. See: https://product-fabric.atlassian.net/browse/DSP-3500 */
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'> div': {
			alignItems: 'start',
			paddingLeft: token('space.100'),
		},
		// bound atlaskit option to the select menu
		width: '100%',
		// modify margin of atlaskit option to account for icon after
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		'> div > div:nth-of-type(2)': {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
			marginRight: ({ hasIconAfter }) => (hasIconAfter ? token('space.300') : token('space.0')),
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	(props) =>
		props.isSingleSelect
			? {
					'> div': {
						boxShadow: props.isFocused
							? `inset 2px 0px 0px ${token('color.border.focused')}`
							: 'none',

						color: props.isDisabled ? 'color.text.disabled' : 'color.text',
					},
				}
			: {},
);
